const PROXY = process.env.NEXT_PUBLIC_IMAGE_PROXY || "";

export default function imageLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}) {
  // No proxy configured — return src directly
  if (!PROXY) return src;

  return `${PROXY}?url=${encodeURIComponent(src)}&w=${width}&q=${quality || 75}&output=webp`;
}
